import axios from 'axios'
import T from 'i18n-react'
import {
  take,
  fork,
  put,
  select,
  cancel,
  call,
  all
} from 'redux-saga/effects'

import {
  POST_LOGIN_USER,
  POST_LOGIN_USER_ERROR,
  POST_LOGOUT_USER,
  POST_LOGOUT_USER_ERROR,
  LOGIN_REQUEST_URL,
  LOGOUT_REQUEST_URL,
} from './constants'

import {
  startLoginUserAsync,
  clearUserAttributes,
  postLoginUserStart,
  postLoginUserSuccess,
  postLoginUserError,
  postLogoutUserStart,
  postLogoutUserSuccess,
  postLogoutUserError,
  updateAuthenticated,
  clearShowError,
  updateShowError,
} from './actions'

import {
  error
} from 'containers/App/Notification/actions'

import {
  usernameSelector,
  passwordSelector,
} from './selectors'

import {
  saveToken,
  removeToken,
} from 'helpers/JwtTokenUtil'

import {
  getRequest as get,
  loginConfig,
} from 'helpers/RequestUtil'

function* authorize(username, password) {
  try {
    yield put(startLoginUserAsync())
    yield put(postLoginUserStart())
    const requestParams = {
      username,
      password,
      user: {
        username,
        password
      }
    }
    const requestConfig = loginConfig()
    const response = yield call(
      axios.post,
      LOGIN_REQUEST_URL,
      requestParams,
      requestConfig
    )
    // get and save the token from the authorization header
    const { headers: { authorization } } = response
    const token = authorization.replace('Bearer ', '')
    saveToken(token)
    yield put(clearUserAttributes())
    yield put(updateAuthenticated(true))
    yield put(postLoginUserSuccess())
  } catch(err) {
    yield put(error(T.translate('pages.login.notification.login_failed')))
    yield put(postLoginUserError(err))
  }
}

function* logout() {
  try {
    yield put(postLogoutUserStart())
    yield call(get, LOGOUT_REQUEST_URL)
    removeToken()
    yield put(clearUserAttributes())
    yield put(postLogoutUserSuccess())
  } catch(error) {
    yield put(postLogoutUserError(error))
  }
}

function* loginFlow() {
  while (true) {
    yield take(POST_LOGIN_USER)
    const username = yield select(usernameSelector)
    const password = yield select(passwordSelector)
    const task = yield fork(authorize, username, password)
    const action = yield take([POST_LOGOUT_USER, POST_LOGIN_USER_ERROR])
    if (action.type === POST_LOGOUT_USER) {
      yield put(clearShowError())
      yield cancel(task)
    } else {
      yield put(updateShowError(true))
    }
  }
}

function* logoutFlow() {
  while (true) {
    yield take(POST_LOGOUT_USER)
    yield put(clearShowError())
    const task = yield fork(logout)
    const action = yield take([POST_LOGIN_USER, POST_LOGOUT_USER_ERROR])
    if (action.type === POST_LOGIN_USER)
      yield cancel(task)
  }
}

function* loadSagas() {
  yield all([
    fork(loginFlow),
    fork(logoutFlow)
  ])
}

export default loadSagas
